import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace LocationApi {
    /**
    *  获取LBS定位开通状态
    */
    export var GetLBSLocationState = (body: any): Promise<any> => {
        return Get(`/csp/Location/GetLBSLocationState?${qs.stringify(body)}`, {});
    };
    /**
    *  开通LBS定位
    */
    export var DredgeLBS = (body: any): Promise<any> => {
        return Get(`/csp/Location/DredgeLBS?${qs.stringify(body)}`, {});
    };
    /**
    *  智能定位
    */
    export var GetLocation = (body: any): Promise<any> => {
        return Get(`/csp/Location/GetLocation?${qs.stringify(body)}`, {});
    };


}